import { Box, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';
import { contentContainerSx } from '@/theme/contentContainerSx';

interface SectionContainersProps {
  children: ReactNode;
  sx?: SxProps;
}

export const SectionContainer = ({
  children,
  sx,
  ...rest
}: SectionContainersProps) => {
  return (
    <Box
      {...rest}
      sx={{
        pb: {
          xs: 1,
          md: 5,
        },
        backgroundColor: 'background.paper',
        ...contentContainerSx,
        maxWidth: '100%',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
